const ths = [
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortable: true,
    sortableId: 'participantPerson.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortable: true,
    sortableId: 'participantPerson.lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortable: true
  },
  {
    id: 5,
    label: 'Registration Date',
    intlKey: 'table.registration_date',
    sortable: true,
    sortableId: 'date'
  },
  {
    id: 6,
    label: 'Level',
    intlKey: 'table.level',
    sortable: true,
    sortableId: 'award.awardLevel.value'
  },
  {
    id: 7,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    sortable: false
  },
  {
    id: 8,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
